import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Shell from '../../components/Shell/Shell';
import { ModalProvider } from '../../context/ModalContext';
import { useApp } from '../../context/AppContextBeta';

import OrganizationsList from './OrganizationsList';
import Organization from './Organization';
import ArchivedAssets from './ArchivedAssets';
import ExpiringContracts from './ExpiringContracts';
import ErrorLogs from './ErrorLogs';
import NotificationsAdmin from './NotificationsAdmin';
import ServiceReportsSingle from './ServiceReportsSingle';

const SuperAdmin = () => {
	const { refreshOrganization } = useApp();

	return (
		<ModalProvider>
			<Shell
				navigation={[
					{ name: 'Organizations', path: '/superadmin' },
					{ name: 'Archived Assets', path: '/superadmin/archived-assets' },
					{ name: 'Expiring Contracts', path: '/superadmin/expiring-contracts' },
					{ name: 'Error Tracking', path: '/superadmin/error-logs' },
					{ name: 'Notifications', path: '/superadmin/notifications' },
				]}
			>
				<Routes>
					<Route index element={<OrganizationsList />} />
					<Route path="archived-assets" element={<ArchivedAssets />} />
					<Route path="expiring-contracts" element={<ExpiringContracts />} />
					<Route path="error-logs" element={<ErrorLogs />} />
					<Route path="notifications" element={<NotificationsAdmin />} />
					<Route path="organization/:id/*" element={<Organization />} />
					<Route path="service-report/:id" element={<ServiceReportsSingle />} />
				</Routes>
			</Shell>
		</ModalProvider>
	);
};

export default SuperAdmin;
